// Centralised content for Zyvora Digital marketing site
export const BRAND = {
  name: "Zyvora Digital",
  tagline: "Helping Businesses Grow Online",
  secondaryTagline: "Build. Market. Scale.",
  email: "zyvoradigitalhq@gmail.com",
  instagram: "@zyvoradigital.in",
  instagramUrl: "https://instagram.com/zyvoradigital.in",
  phones: [
    { label: "Primary", value: "+91 79047 58182", tel: "+917904758182" },
    { label: "Secondary", value: "+91 87784 46732", tel: "+918778446732" },
    { label: "Alternate", value: "+91 90801 54156", tel: "+919080154156" },
  ],
  whatsappNumber: "917904758182",
  whatsappDisplay: "+91 79047 58182",
  businessHours: "Mon - Sat · 9:00 AM – 7:00 PM",
  responseTime: "Within 24 Hours",
  logoFull: "https://customer-assets.emergentagent.com/job_growth-agency-pro-3/artifacts/8gswxeuk_file_00000000e04471fb8e3f547031afc374.png",
  logoMark: "https://customer-assets.emergentagent.com/job_growth-agency-pro-3/artifacts/8gswxeuk_file_00000000e04471fb8e3f547031afc374.png",
};

export const CUSTOM_SOLUTION_COPY =
  "Contact us for a customized quote tailored to your goals and budget.";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Packages", path: "/packages" },
  { label: "Case Studies", path: "/case-studies" },
  { label: "Policies", path: "/policies" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Professional Solutions" },
  { value: 24, suffix: "h", label: "Fast Turnaround" },
  { value: 100, suffix: "%", label: "Mobile Responsive" },
  { value: 100, suffix: "%", label: "SEO Friendly" },
  { value: 99, suffix: "%", label: "Client Satisfaction" },
];

export const WHY_CHOOSE = [
  { title: "Professional Solutions", desc: "Enterprise-grade quality, delivered with attention to detail on every project.", icon: "Award" },
  { title: "Business Growth Focused", desc: "Every solution is designed to help businesses generate more customers.", icon: "TrendingUp" },
  { title: "Transparent Process", desc: "Clear process with no hidden surprises — you're in the loop throughout.", icon: "ShieldCheck" },
  { title: "Personalized Support", desc: "Direct communication and dedicated client assistance.", icon: "HeartHandshake" },
  { title: "Modern Technology", desc: "AI-assisted workflows and modern tools for premium output.", icon: "Cpu" },
  { title: "Fast Turnaround", desc: "Projects delivered quickly without compromising quality.", icon: "Zap" },
];

export const INDUSTRIES = [
  "Travel Agencies", "Hotels", "Restaurants", "Salons", "Gyms",
  "Educational Institutions", "Retail Businesses", "Real Estate", "Startups", "Local Businesses"
];

// Services without pricing — deliverables only
export const SERVICES = [
  {
    slug: "website-development",
    title: "Website Development",
    icon: "Globe",
    desc: "Conversion-focused websites engineered to attract leads, look stunning on every device, and rank on Google.",
    tiers: [
      { name: "Starter Website", features: ["Up to 5 Pages", "Mobile Responsive Design", "WhatsApp Integration", "Contact Form", "Basic SEO Setup"] },
      { name: "Business Website", popular: true, features: ["Up to 10 Pages", "Premium Design", "Google Maps Integration", "Inquiry Forms", "Basic SEO", "Social Media Integration"] },
      { name: "Premium Website", features: ["Custom Design", "Advanced Features", "Blog Setup", "Speed Optimization", "SEO Optimization"] },
    ],
  },
  {
    slug: "google-business-profile",
    title: "Google Business Profile",
    icon: "MapPin",
    desc: "Get discovered on Google Search and Maps with a fully optimised business profile that converts searchers into customers.",
    tiers: [
      { name: "Profile Setup", features: ["Profile Creation", "Business Information Setup", "Category Selection", "Contact Details Setup"] },
      { name: "Profile Optimization", popular: true, features: ["Complete Optimization", "Service Listings", "Business Description", "Photos Upload", "Local SEO Improvements"] },
    ],
  },
  {
    slug: "social-media-marketing",
    title: "Social Media Marketing",
    icon: "Share2",
    desc: "Consistent, on-brand social content that builds trust, grows reach, and turns followers into paying customers.",
    tiers: [
      { name: "Starter Package", features: ["12 Posts Monthly", "Captions", "Hashtags"] },
      { name: "Growth Package", popular: true, features: ["12 Posts", "4 Reels", "Content Calendar", "Monthly Report"] },
      { name: "Premium Package", features: ["Daily Management", "Reels & Graphics", "Content Strategy", "Growth Support"] },
    ],
  },
  {
    slug: "logo-design",
    title: "Logo Design",
    icon: "PenTool",
    desc: "Memorable, professional logos that instantly communicate the right brand personality.",
    tiers: [
      { name: "Basic Logo", features: ["2 Concepts", "Final PNG + JPG", "Single Revision"] },
      { name: "Professional Logo", popular: true, features: ["4 Concepts", "Vector + Source Files", "Brand Color Palette", "Revisions Included"] },
    ],
  },
  {
    slug: "business-card-design",
    title: "Business Card Design",
    icon: "CreditCard",
    desc: "Premium business cards that make a powerful first impression in every meeting.",
    tiers: [
      { name: "Standard Design", features: ["Single-Side Design", "Print-Ready Files"] },
      { name: "Premium Design", popular: true, features: ["Double-Side Design", "Premium Finishes Mockup", "Print-Ready Files"] },
    ],
  },
  {
    slug: "brochure-design",
    title: "Brochure Design",
    icon: "BookOpen",
    desc: "Professional brochures that present your services clearly and persuasively.",
    tiers: [
      { name: "Single Page Flyer", features: ["A4 Single Page", "Print-Ready PDF"] },
      { name: "Bi-Fold Brochure", features: ["2-Fold Layout", "Print-Ready PDF"] },
      { name: "Tri-Fold Brochure", popular: true, features: ["3-Fold Layout", "Print-Ready PDF"] },
    ],
  },
  {
    slug: "whatsapp-business",
    title: "WhatsApp Business Setup",
    icon: "MessageCircle",
    desc: "Turn WhatsApp into a powerful sales and support channel with quick replies, catalogues and automated greetings.",
    tiers: [
      { name: "Basic Setup", features: ["Profile Setup", "Quick Replies", "Greeting Message"] },
      { name: "Advanced Setup", popular: true, features: ["Catalogue Setup", "Auto Responses", "Labels & Tags", "Training Session"] },
    ],
  },
  {
    slug: "seo-services",
    title: "SEO Services",
    icon: "Search",
    desc: "Rank higher on Google, attract organic traffic and stay ahead of the competition.",
    tiers: [
      { name: "Basic SEO", features: ["On-Page SEO", "Meta Tags", "Speed Optimization"] },
      { name: "Local SEO", popular: true, features: ["Local SEO Audit", "Google Maps Optimization", "Citations & Listings", "Monthly Report"] },
    ],
  },
  {
    slug: "ai-business-solutions",
    title: "AI Business Solutions",
    icon: "Sparkles",
    desc: "Automate repetitive work and serve customers 24/7 with AI chatbots and custom AI workflows.",
    tiers: [
      { name: "AI Chatbot Setup", features: ["Custom Chatbot", "Website Integration", "FAQ Training"] },
      { name: "Business Automation", popular: true, features: ["Workflow Automation", "CRM Integration", "Lead Capture"] },
      { name: "Custom AI Solutions", features: ["Tailored Architecture", "Dedicated Support"] },
    ],
  },
];

// Packages — no pricing
export const PACKAGES = [
  {
    name: "Starter Package",
    bestFor: "New Businesses",
    items: ["Website Development", "Google Business Profile Setup", "Business Card Design"],
  },
  {
    name: "Growth Package",
    bestFor: "Growing Businesses",
    popular: true,
    items: ["Website Development", "Logo Design", "Google Business Profile", "WhatsApp Business Setup"],
  },
  {
    name: "Premium Package",
    bestFor: "Businesses Ready To Scale",
    items: ["Premium Website", "Branding", "Social Media Setup", "Google Business Profile"],
  },
];

// Case Studies (replaces Portfolio)
export const CASE_STUDIES = [
  {
    slug: "sandhukadai",
    name: "Sandhukadai",
    industry: "Hardware Shop · Madurai",
    challenge: [
      "Limited online presence",
      "Customers relied mainly on word-of-mouth",
      "Business information was not easily discoverable online",
    ],
    solution: [
      "Created and optimized online business profiles",
      "Standardized business information across platforms",
      "Improved online visibility and customer contact accessibility",
    ],
    results: [
      "Increased online discoverability",
      "More customer enquiries through digital channels",
      "Stronger local brand credibility",
    ],
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "prabhu-agencies",
    name: "Prabhu Agencies",
    industry: "Wholesale Cold Drinks & Beverages",
    challenge: [
      "Retailers and distributors found it difficult to locate business information online",
      "Limited digital footprint",
    ],
    solution: [
      "Established a professional online presence",
      "Organized business details, contact information, and product categories online",
      "Improved accessibility for potential customers and partners",
    ],
    results: [
      "Better online visibility",
      "Easier communication with retailers",
      "More professional business image",
    ],
    image: "https://images.unsplash.com/photo-1550505095-81378a674395?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "local-travel-agency",
    name: "Local Travel Agency",
    industry: "Travel & Tourism",
    challenge: [
      "No website or structured online presence",
      "Customer enquiries came only through personal contacts",
    ],
    solution: [
      "Developed a professional online presence",
      "Created business profiles and inquiry channels",
      "Improved customer accessibility",
    ],
    results: [
      "More enquiry opportunities",
      "Increased customer trust",
      "Better brand recognition",
    ],
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "local-restaurant",
    name: "Local Restaurant",
    industry: "Food & Beverage",
    challenge: [
      "Low visibility among new customers",
      "Inconsistent business information online",
    ],
    solution: [
      "Optimized online listings",
      "Improved visibility on search and maps platforms",
      "Added updated contact and business details",
    ],
    results: [
      "Increased customer discovery",
      "Improved customer engagement",
      "Better online reputation",
    ],
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
  },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Free Consultation", desc: "We listen to your goals and audit your current online presence at no cost." },
  { step: "02", title: "Requirement Analysis", desc: "We map features, pages and timelines tailored to your business stage." },
  { step: "03", title: "Quotation Approval", desc: "Transparent, all-inclusive quote with zero hidden charges." },
  { step: "04", title: "50% Advance Payment", desc: "We secure your slot and kick off the project." },
  { step: "05", title: "Project Development", desc: "Our team designs, builds, and iterates with regular updates." },
  { step: "06", title: "Review & Revisions", desc: "One complimentary revision round to perfect the final details." },
  { step: "07", title: "Final Payment", desc: "Balance due once you’ve approved the final product." },
  { step: "08", title: "Project Delivery", desc: "Launch day! Plus full ownership transfer and onboarding." },
];

export const POLICIES = [
  { title: "Payment Policy", points: ["50% advance before work starts", "Remaining 50% before final delivery", "Domain and hosting charges payable in advance"] },
  { title: "Revision Policy", points: ["One revision round included", "Additional revisions charged separately"] },
  { title: "Domain & Hosting Policy", points: ["Domain and hosting are separate charges unless specifically included", "Annual renewal charges apply"] },
  { title: "Ownership Policy", points: ["Ownership transfers after full payment"] },
  { title: "Cancellation Policy", points: ["Advance payments are non-refundable once work has started"] },
];

// Real client testimonials only
export const TESTIMONIALS = [
  {
    name: "Prabhu",
    role: "Owner, Sandhukadai · Madurai",
    quote: "Professional service and excellent support. Our business became easier to find online and customers can now contact us more easily. Highly recommended.",
    rating: 5,
  },
  {
    name: "Sudha",
    role: "Prabhu Agencies",
    quote: "The online presence created by Zyvora Digital improved how customers and retailers discover our business. The process was smooth and professional.",
    rating: 5,
  },
];

export const TESTIMONIALS_NOTE =
  "More client success stories and testimonials will be added as new projects are completed.";

export const FAQS = [
  { q: "How long does a website take?", a: "Most starter websites are delivered in 5–7 working days. Business and premium websites typically take 2–3 weeks based on complexity and content readiness." },
  { q: "Do I need a domain?", a: "Yes — every website needs a domain. We can help you choose and register one. Domain & hosting are billed separately on an annual basis." },
  { q: "Can I update my website later?", a: "Absolutely. We can build it on a content management system so you can update content yourself, or we offer affordable maintenance plans." },
  { q: "Do you provide support?", a: "Yes. We offer post-launch support, optional maintenance plans and direct WhatsApp access to our team." },
  { q: "What payment methods are accepted?", a: "We accept UPI, bank transfer, and major debit/credit cards. International clients can pay via PayPal or wire transfer." },
  { q: "Do you work outside Tamil Nadu?", a: "Yes — we serve clients across India and overseas. Everything is delivered remotely with clear communication." },
  { q: "Is hosting included?", a: "Hosting is not included by default. We recommend reliable hosting partners and can set everything up for you at cost." },
  { q: "Can you redesign my existing website?", a: "Yes. We frequently redesign outdated websites with modern UI, faster performance and better SEO." },
];

export const SERVICE_OPTIONS = [
  "Website Development",
  "Google Business Profile",
  "Social Media Marketing",
  "Logo Design",
  "Business Card Design",
  "Brochure Design",
  "WhatsApp Business Setup",
  "SEO Services",
  "AI Business Solutions",
  "Complete Package",
  "Other",
];
